import { apiGateResult } from '../../utils/types';
import { tokenAxios } from '../index';

export const requestApiGate = async () => {
  const result = await tokenAxios.get<apiGateResult>('/apiGate');
  return result.data;
};
